import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApplicationsHttp } from 'providers/http/ApplicationsHttp';
import { TokenStorage } from 'providers/TokenStorage';
import { MessageStorage } from 'util/MessageStorage';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

declare let PRODUCT;

@Component({
  selector: 'aplications',
  templateUrl: './aplications.component.html',
  styleUrls: ['./aplications.component.css']
})
export class AplicationsComponent implements OnInit, OnDestroy {
  productsList: any[] = [];
  products = [];
  alive = true;
  private subApps;
  constructor(private appsHttp: ApplicationsHttp,
    private tokenStorage: TokenStorage,
    private cookieService: CookieService,
    private router: Router) {
    this.products = [];
  }

  getProductsAgent() {
    if ( this.alive ) {
      this.subApps =  this.appsHttp.getProductsAgent({})
      .subscribe((resp) => {
        if (resp.ProductForAgentList.length > 0) {
          this.productsList = resp.ProductForAgentList;
        }
        /**
         * se llama asi mismo
         */
        setTimeout(() => {
          this.getProductsAgent();
        }, 300000); //=> 1 hora
      });
    }
  }

  productsClick(product) {
    let token: any;
    if ( this.tokenStorage.getToken() ) {
      token = this.tokenStorage.getToken();
    } else if ( this.tokenStorage.getCookie() ) {
      token = this.tokenStorage.getCookie();
    }

    let url = '';

    if ( product.ACTIVO === 'A' ) {
        if ( product.IDPRODUCT === '04') {
            this.router.navigateByUrl('/home');
        } else {
            url = product.URLAPP + '?noRedirect=true';
            // window.open(url + '&token=' + token, '_blank');
            window.open(url, '_blank');
        }
        
    } else {
        url = product.URLAPP;
        window.open(url , '_blank');
    }
  }

  ngOnInit() {
    // this.getProductsAgent();
    if (this.tokenStorage.getToken() || this.tokenStorage.getCookie()) {
      this.getProductsAgent();
    } else {
      this.tokenStorage.deleteCookie();
      this.tokenStorage.resetToken();
      window.location.href = 'index?msg=Su sesión ha expirado. Por favor vuelva a ingresar.&msgType=info';
    }
    
  }

  ngOnDestroy() {
    this.subApps.unsubscribe();
    this.alive = false;
  }

}
